
const ModelHandlingUnit = {
    _id: {
        id: '_id',
        typeof: 'string',
        required: true,
        default: '',
        description: 'Unique identifier for the handling unit.',
        fr: 'Identifiant de l\'UM',
        en: 'HU ID',
        isVisible: false,
        disabled: true
    },
    huCode: {
        id: 'huCode',
        typeof: 'string',
        required: true,
        default: '',
        description: 'Unique code for the handling unit.',
        fr: 'Code de l\'UM',
        en: 'HU Code',
        isVisible: true,
        disabled: false
    },
    huDate: {
        id: 'huDate',
        typeof: 'date',
        required: true,
        default: null,
        description: 'Date of the handling unit.',
        fr: 'Date de l\'UM',
        en: 'HU Date',
        isVisible: true,
        disabled: false
    },
    huWeight: {
        id: 'huWeight',
        typeof: 'numberFloat',
        required: true,
        default: 0,
        description: 'Weight of the handling unit in kilograms.',
        fr: 'Poids en kg',
        en: 'Weight in kg',
        isVisible: true,
        disabled: false
    },
    huLength: {
        id: 'huLength',
        typeof: 'numberFloat',
        required: true,
        default: 0,
        description: 'Length in meters.',
        fr: 'Longueur (en cm)',
        en: 'Length (in cm)',
        isVisible: true,
        disabled: false
    },
    huWidth: {
        id: 'huWidth',
        typeof: 'numberFloat',
        required: true,
        default: 0,
        description: 'Width in meters.',
        fr: 'Largeur (en cm)',
        en: 'Width (in cm)',
        isVisible: true,
        disabled: false
    },
    huHeight: {
        id: 'huHeight',
        typeof: 'numberFloat',
        required: true,
        default: 0,
        description: 'Height in meters.',
        fr: 'Hauteur (en cm)',
        en: 'Height (in cm)',
        isVisible: true,
        disabled: false
    },
    huVolume: {
        id: 'huVolume',
        typeof: 'numberFloat',
        required: false,
        default: 0,
        description: 'Automatically calculated volume: L × W × H.',
        fr: 'Volume en m³',
        en: 'Volume in m³',
        isVisible: true,
        disabled: true
    },
    huLinearMeters: {
        id: 'huLinearMeters',
        typeof: 'numberFloat',
        required: false,
        default: 0,
        description: 'Footprint / 2.4 (semi-trailer width).',
        fr: 'Mètres linéaires',
        en: 'Linear meters',
        isVisible: true,
        disabled: false
    },
    isStackable: {
        id: 'isStackable',
        typeof: 'boolean',
        required: false,
        default: false,
        description: 'Whether the unit can be stacked.',
        fr: 'Gérbable',
        en: 'Stackable',
        isVisible: true,
        disabled: false
    },
    isReturnable: {
        id: 'isReturnable',
        typeof: 'boolean',
        required: false,
        default: false,
        description: 'Whether the unit is returnable.',
        fr: 'Retour palette',
        en: 'Returnable',
        isVisible: true,
        disabled: false
    },
    huWeightToVolumeRatio: {
        id: 'huWeightToVolumeRatio',
        typeof: 'numberFloat',
        required: false,
        default: 0,
        description: 'Weight-to-volume ratio (RPV).',
        fr: 'Rapport poids-volume en kg/m³',
        en: 'Weight-volume ratio in kg/m³',
        isVisible: true,
        disabled: true
    },
    huChargeableWeight: {
        id: 'huChargeableWeight',
        typeof: 'numberFloat',
        required: false,
        default: 0,
        description: 'Taxable weight: max(weight, volume × ratio).',
        fr: 'Poids taxable en kg',
        en: 'Chargeable weight in kg',
        isVisible: true,
        disabled: true,
        info: 'Chargeable weight in kg (max(weight, volume × ratio))'

    }
};



export {ModelHandlingUnit}